import useStyles from './styles';
import {Typography,Button,Grid, Container,CardActions,Card,CardMedia,CardContent} from '@material-ui/core';
import MoreHorizIcon  from '@material-ui/icons/MoreHoriz';
import Modal from '../modals/Modal';
import React, { useState } from 'react';
import datacenter from '../../assets/newDc.png';
import elasticsearch from '../../assets/elasticsearch.png';
import mern from '../../assets/mern.png';
import dogbreed from '../../assets/multiclass.png';
import rentapp from '../../assets/rent.png';
import equipment from '../../assets/web_proj.png';
import yelpcamp from '../../assets/yelpcamp.png';
const Project = (props)=>{
    const [show,setShow]=useState({
        value:false,
        image:''
    });
    const classes = useStyles();
    const addShowHandler = (event)=>{
        console.log(event.target.id);
        const obj = {
            value:true,
            image:event.target.id
        }
        console.log(obj)
        setShow(obj);
    }
    const cards = [
        {
            id:1,
            name:'Equipment details',
            img:equipment,
            details:'It is a mern stack application built for web technologies project. It has features for the user to enter the details of different equipments based on different category and also stores the description of it ',
            link:'https://github.com/akashhegde2012/equipment_details'
        },
        {
            id:2,
            name:'Data Center',
            img:datacenter,
            details:'It is a Data center build for M S Ramaiah Institute of Technology. I have used ejs template,JavaScript and CSS for front-end and Express.js, Node.js and MYSQL database in the Backend',
            link:'https://github.com/akashhegde2012/Data_Center'
        },
        {
            id:3,
            name:'Yelp Camp',
            img:yelpcamp,
            details:'It is a REST api built with Node.js,MongoDB and Express backend and ejs,Bootstrap for front end. It has basic crud features where user can add details of a campground and view it',
            link:'https://github.com/akashhegde2012/YelpCamp'
        },
        {
            id:4,
            name:'Elastic Search',
            img:elasticsearch,
            details:'It is an information retrieval project using elasticsearch server. It is implementation of full text search using elastic search. Flask and elastic search were used in this project',
            link:'#'
        },
        {
            id:5,
            name:'Album app',
            img:mern,
            details:'It is an album application to store various memories. It is built on React.js for front-end and uses Node.js,Express.js and mongoDB for back-end',
            link:'https://github.com/akashhegde2012/Album'
        },
        {
            id:6,
            name:'Rent app',
            img:rentapp,
            details:'It is an application where the owners and tenants can give or take a house for rent. It is built with Node.js,MongoDB and Express backend and ejs,Bootstrap for front end.',
            link:'https://github.com/ChinmayBhatkal/wHACKiest2021_fuxsocy'
        },
        {
            id:7,
            name:'Dog Breed Classification',
            img:dogbreed,
            details:'It is a Deep learning project using TensorFlow, Convolution Neural Network. It classifies different breeds of dogs by taking the photo as the input',
            link:'https://colab.research.google.com/drive/1tER8eUK2qoZPLslQoaHSMZt9fP7klild?usp=sharing'
        },
    ];
    const cancelHandler = ()=>{
        const obj = {
            value:false,
            image:''
        };
        console.log(obj)
        setShow(obj);
    }
    return(
        <React.Fragment>
            {show.value && <Modal image={show.image} onCancel={cancelHandler}/> }
            <main className={classes.main}>
        <Container className={classes.container} maxWidth='md'>
                    <Typography variant='h2' align='center' color='textPrimary' gutterBottom>
                    Personal Projects
                    </Typography>
                    <Typography variant = 'h5' align='center' color = 'textSecondary'>
                        These are some of the personal projects I have made during my study. I have use various technologies in each of them
                    </Typography>
        </Container>
        <Container  className={classes.cardGrid} maxWidth='lg'>
			<Grid container spacing={4}>
				{cards.map(card=>(
					<Grid key={card.id} item xs={12} sm={6} md={4}>
					<Card className={classes.card}>
						<CardMedia className={classes.cardMedia} image={card.img} title="image title"/>
                        <div className={classes.overlay2}>
                            <Button style={{color:'white'}}  onClick={addShowHandler} size='small' >
                                <MoreHorizIcon id={card.img}  fontSize='default'/>
                            </Button>
                        </div>
						<CardContent className={classes.cardContent}>
							<Typography gutterBottom variant='h5'>
								{card.name}
							</Typography>
							<Typography gutterBottom variant='body2'>
                                {card.details}
							</Typography>
						</CardContent>
						<CardActions>
							<a href={card.link}><Button size='small' color='primary'>View</Button></a>
						</CardActions>
					</Card>
				</Grid>
				))}
			</Grid>
		</Container>
        </main>
        </React.Fragment>
    )
}
export default Project
